import { render, staticRenderFns } from "./XinzengTidan.vue?vue&type=template&id=ecacd7b2&scoped=true&"
import script from "./XinzengTidan.vue?vue&type=script&lang=js&"
export * from "./XinzengTidan.vue?vue&type=script&lang=js&"
import style0 from "./XinzengTidan.vue?vue&type=style&index=0&id=ecacd7b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecacd7b2",
  null
  
)

export default component.exports